/* global __DEVELOPMENT__ */
import ab from 'react-redux-hydra';

import marketplace from 'cfg/marketplace.json';

export const triggerAssignment = ab.actions.triggerAssignmentFactory({ domain: marketplace.cookieDomain });
export const { isAssigned } = ab;

// Set rrh cookiename
ab.config.setConfig('cookieName', typeof(__DEVELOPMENT__) !== 'undefined' && __DEVELOPMENT__ ? 'zfc-dev' : 'zfc');

export function isInAssignment(assignment) {
  return assignment && assignment.index !== 0;
}

export function getAssignmentGroup(name, state) {
  return state ? ab.assignmentGroup(name, state) : 0;
}
